import { LayoutProps, rankWith, uiTypeIs } from '@jsonforms/core';
import {
    ResolvedJsonFormsDispatch,
    withJsonFormsLayoutProps,
} from '@jsonforms/react';
import { cloneDeep } from 'lodash';
import './style.scss';
import { useDynamicFormContext } from '../../../DynamicFormContext';
import { getElements } from '../../../../../utils/DynamicForms';
import { TruAction, TruNavigateAction } from '../../../../../types';


export const QuoteActionsLayout = (props: LayoutProps) => {
    const { formData } = useDynamicFormContext();

    return (
        <div className="tru-layout-quote-actions">
            {getElements(props.uischema).map((element: any, index) => {
                const updatedElement = cloneDeep(element);
                if (!formData.mustRequote) {
                    updatedElement.actions = [
                        {
                            key: "validate",
                            options: {
                                dataPath: "coverages",
                                schemaScope: "properties.coverages"
                            }
                        },
                        ...updatedElement.actions.map(
                            (a: TruAction) => {
                                if (a.key === 'navigate') {
                                    const action: TruNavigateAction = a;
                                    action.data.search = action.data.search?.replaceAll(
                                        '$quoteId',
                                        `${props.cells ? props?.cells[0] : ""}`,
                                    );
                                    return action;
                                }
                                return a;
                            },
                        )
                    ]
                }

                return (
                    <ResolvedJsonFormsDispatch
                        {...props}
                        uischema={updatedElement}
                        key={index}
                    />
                );
            })}
        </div>
    );
};

export const QuoteActionsEntry = {
    tester: rankWith(1, uiTypeIs('QuoteActionsLayout')),
    renderer: withJsonFormsLayoutProps(QuoteActionsLayout),
};
